import type { ComponentProps } from 'react'
import { TableHeader, type TableHeaderBaseProps } from './TableHeader'
import type { TableBodyBaseProps } from './TableBody'
import { TableBody } from './TableBody'

type TableProps = {
  header?: TableHeaderBaseProps
} & TableBodyBaseProps &
  ComponentProps<'table'>

export const Table = ({ children, header, rows, renderRow, ...props }: TableProps) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left text-secondary h-[1px]" {...props}>
        {children ? (
          children
        ) : (
          <>
            {header && <TableHeader {...header} />}
            <TableBody rows={rows} renderRow={renderRow} />
          </>
        )}
      </table>
    </div>
  )
}
